import type { FC } from "react"
import { useShallow } from "zustand/shallow"

import type { PurchaseOrderLineWithReceiptContext } from "../../types"
import { formatPalletCount, resolveGoodsReceiptPurchaseOrderLineQuantity } from "../../utils"

import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { formatNumber } from "@/utils/number"

interface GoodsReceiptPurchaseOrderLineQuantityProps {
  purchaseOrderLine: PurchaseOrderLineWithReceiptContext
}

export const GoodsReceiptPurchaseOrderLineQuantity: FC<GoodsReceiptPurchaseOrderLineQuantityProps> = ({
  purchaseOrderLine,
}) => {
  const quantity = resolveGoodsReceiptPurchaseOrderLineQuantity(purchaseOrderLine)
  const uoms = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const usUom = uoms.find((uom) => uom.id === quantity.regional.us.uomId)
  const metricUom = uoms.find((uom) => uom.id === quantity.regional.metric.uomId)

  return (
    <>
      {formatPalletCount(quantity.palletsCount)}
      <br />
      {formatNumber(quantity.regional.us.quantity)}&nbsp;{usUom?.name} (
      {formatNumber(quantity.regional.metric.quantity)}
      &nbsp;{metricUom?.name})
    </>
  )
}
